const space = {
  ZERO: 0,
  XXXXS: 2,
  XXXS: 4,
  XXS: 6,
  XS: 8,
  S: 12,
  M: 16,
  L: 20,
  XL: 24,
  XXL: 32,
  XXXL: 36,
  XXXXL: 40,
};

export enum SpaceEnums {
  XXXXS = 'XXXXS',
  XXXS = 'XXXS',
  XXS = 'XXS',
  XS = 'XS',
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = 'XXL',
  XXXL = 'XXXL',
}

export type Space = typeof space;

export default space;
